import { motion, useReducedMotion } from "framer-motion";

import { cn } from "@/lib/utils";
import { GuardTone, GUARD_TONES } from "./guard-tones";

const ANEIS = [
  { size: "h-[22rem] w-[22rem]", duracao: 30, direcao: 1 },
  { size: "h-[32rem] w-[32rem]", duracao: 45, direcao: -1 },
];

/**
 * Fundo das telas de guarda: grade sutil e dois anéis tracejados girando em
 * sentidos opostos atrás do ícone. Geometria em vez de brilho — não lava a cor
 * no tema escuro, como acontecia com o halo borrado.
 */
export function GuardBackground({ tone }: Readonly<{ tone: GuardTone }>) {
  const t = GUARD_TONES[tone];
  const semMovimento = useReducedMotion();

  return (
    <>
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.035] [mask-image:radial-gradient(closest-side,black,transparent)] dark:opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(to right, currentColor 1px, transparent 1px), linear-gradient(to bottom, currentColor 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />

      {ANEIS.map((anel) => (
        <motion.div
          key={anel.size}
          aria-hidden
          className={cn(
            "pointer-events-none absolute left-1/2 top-1/2 rounded-full border border-dashed border-current opacity-[0.12]",
            anel.size,
            t.icon,
          )}
          style={{ x: "-50%", y: "-50%" }}
          animate={semMovimento ? undefined : { rotate: 360 * anel.direcao }}
          transition={{ duration: anel.duracao, repeat: Infinity, ease: "linear" }}
        />
      ))}
    </>
  );
}
